import Inspection from "@/modules/dis/service/inspection/Inspection";
import Order from "@/modules/dis/service/order/Order";
import Ics from "@/modules/dis/service/ics/Ics";
import Budget from "@/modules/dis/service/ics/Budget";

export default {
    order     : Order,
    inspection: Inspection,
    ics       : Ics,
    budget    : Budget
}